module.exports = __webpack_public_path__ + "img/icon7.0e91444e.png";